<style>
#systemLog{
	/* padding:30px 30px 8px 30px!important; */
	height: calc(100vh - 128px)!important;
}
#systemLog .q-table__middle{
	overflow-y: hidden !important;
	overflow-x: auto !important;
	height:calc(100% - 48px)!important;
	width: 100%;
}
#systemLog .q-table{
	overflow: hidden !important;
	height:100% !important;
	width: 100%;
}
#systemLog tbody{
	display: block;
	max-height: calc(100vh - 300px);
	height:100%;
	width: 100%;
	overflow: auto;
	webkit-overflow-scrolling: touch;
	will-change: scroll-position;
}
#systemLog .q-table thead{
	height: 48px;
	display: block;
}
#systemLog .q-table thead tr{
	width: 100%;
	display: table;
}
#systemLog .q-table tbody tr{
	width: 100%;
	display: table;/*table-row*/
}
#systemLog .q-table th, #systemLog .q-table tbody td{
    font-size: 0.95rem;
}
#systemLog .q-table th, #systemLog .q-table td {
    padding: 7px 8px;
}
#systemLog .q-table td {
	word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
#systemLog .q-table__bottom{
	color: #888;
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 0 15px;
}
#systemLog .q-table__bottom, #systemLog .q-table__bottom .q-if {
    font-size: 0.88rem;
}
</style>
<template>
  <q-page id="systemLog" padding>
  	<q-card class="fit">
  		<q-card-section style="height: 60px;padding:10px 15px;" :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
  			<q-field :color="use_date?'primary':'grey-5'" style="width:270px;padding: 0;float:right;" rounded outlined dense>
  				<template v-slot:prepend>
  					<q-icon @click="use_date=!use_date" :name="'far fa-'+(use_date?'calendar-check':'calendar-times')" :class="['cursor-pointer',use_date?'text-blue-6':'text-grey-6']" style="font-size:19px;margin-right:6px;">
  						<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{use_date?'使用日期':'不使用日期'}}</q-tooltip>
  					</q-icon>
  					<span style="width:78px;font-size:15px;text-align:center;min-height:22px;">{{date1}}
  						<q-popup-proxy v-if="use_date" transition-show="scale" transition-hide="scale">
  						  <q-date v-model="date1" :options="dateOpt1" :minimal="date1 === null ? true: false"/>
  						</q-popup-proxy>
  					</span>
  				</template>
  				<template v-slot:control>
  				  <div class="self-center full-width no-outline text-right" tabindex="0" style="text-align:center;">~</div>
  				</template>
  				<template v-slot:append>
  					<span style="width:78px;font-size:15px;text-align:center;">{{date2}}</span>
  					<q-popup-proxy v-if="use_date" transition-show="scale" transition-hide="scale">
  					  <q-date v-model="date2" :options="dateOpt2"/>
  					</q-popup-proxy>
  				</template>
  				<template v-slot:after>
  				  <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense />
  				</template>
  			</q-field>
  		</q-card-section>
  		<q-separator />
  		<q-card-section class="q-pa-none" style="height:calc(100% - 60px);"><!-- :selected.sync="selected" selection="multiple"-->
  			<q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page" :rows-per-page-options="[15,20,30]" row-key="id">
  				<tr slot="header" slot-scope="props">
  					<q-th key="id" :props="props" style="width:6%;min-width:100px;">ID</q-th>
          			<q-th key="ip" :props="props" style="width:18%;min-width:150px">{{$t('ip')}}</q-th>
					<q-th key="modelName" :props="props" style="width:15%;min-width:150px">{{$t('system.model')}}</q-th>
					<q-th key="className" :props="props" style="width:35%;min-width:150px">{{$t('system.class')}}</q-th>
					<q-th key="createTime" :props="props" style="width:18%;min-width:150px">{{$t('createTime')}}</q-th>
          			<q-th key="opt" :props="props" style="width:8%;min-width:70px;">{{$t('opt')}}</q-th>
          		</tr>
          		<q-tr slot="body" slot-scope="props" :props="props">
          			<!--<q-td key="id" :props="props" style="width:6%;">{{ (props.row.__index+1)+(curPage-1)*page.rowsPerPage }}</q-td>-->
          			<q-td key="id" :props="props" style="width:6%;min-width:100px">{{ props.row.id }}</q-td>
          			<q-td key="ip" :props="props" style="width:18%;min-width:150px">
						<q-icon :name="'fa fa-'+(props.row.successed == 'INFO'?'check':'times')" :class="[props.row.successed == 'INFO'?'text-positive':'text-red']" style="font-size:15px;margin-right:5px;"/>{{ props.row.ip }}
					</q-td>
					<q-td key="modelName" :props="props" style="width:15%;min-width:150px">{{ props.row.modelName }}</q-td>
					<q-td key="className" :props="props" style="width:35%;min-width:150px">{{ props.row.className }}</q-td>
          			<q-td key="createTime" :props="props" style="width:18%;min-width:150px">{{ props.row.createTime |parseDateTime}}</q-td>
          			<q-td key="opt" :props="props" style="width:8%;min-width:70px;">
          				<q-btn @click="btnClick(0,props.rowIndex)" icon="fas fa-search" color="positive" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('detail')}}</q-tooltip>
          				</q-btn>
          			</q-td>
          		</q-tr>
          		<div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
          			<q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary" size="sm" round dense/>
          			<div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }} </div>
          			<q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round dense/>
          		</div>
  			</q-table>
  		</q-card-section>
  	</q-card>

	<q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
		<q-card v-if="content"  :class="[screenType?'q-pa-lg':'q-pa-sm']" :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
	    <q-card-section><div class="text-h6">{{$t('system.dialog')}}</div></q-card-section>
	    <q-card-section>
		  <div v-if="dialogType===0" style="line-height:38px;font-size:15px;margin:0 auto;">
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('ip')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0">{{content.ip}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('status')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0">
						<q-icon :name="'fa fa-'+(content.successed == 'INFO'?'check':'times')" :class="[content.successed == 'INFO'?'text-positive':'text-red']" style="font-size:16px;margin-right:5px;"/>{{content.successed == 'INFO'?'Success':'Fail'}}
					</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('system.model')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0">{{content.modelName}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('system.class')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0">{{content.className}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('system.des')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0" style="word-wrap:break-word;">{{content.description}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('system.param')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0" style="word-wrap:break-word;">{{content.actionArgs}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('system.msg')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0" style="white-space:pre-wrap;max-height:90px;overflow-y:auto;">{{content.message}}</div>
			  	</template>
			  </q-field>
			  <q-field borderless>
			  	<template v-slot:prepend><span style="font-size:15px;">{{$t('createTime')}}：</span></template>
			  	<template v-slot:control>
			  		<div class="self-center full-width no-outline" tabindex="0">{{content.createTime |parseDateTime}}</div>
			  	</template>
			  </q-field>
		  </div>
	    </q-card-section>
	    <q-card-actions align="right" class="bg-white text-teal">
	    	<q-btn :label="$t('close')" color="primary" class="q-mr-md" v-close-popup/>
	    </q-card-actions>
	  </q-card>
	</q-dialog>
  </q-page>
</template>
<script>
export default {
  name: 'systemLog',
  data () {
    return {
    	keyword:null,
		use_date:true,
		date1:null,
		date2:parseDate1(DATE.getTime()),
    	selected:[],
    	total:0,
    	curPage:1,
    	page:{ page:1, rowsPerPage:20 },
    	loading:false,
    	columns: [{ name: 'id', field: 'id', align: 'left', sortable: true},
        { name: 'ip', field: 'ip', align: 'left', sortable: true },
        { name: 'modelName', field: 'modelName', align: 'left', sortable: true },
		{ name: 'className', field: 'className', align: 'left', sortable: true },
        { name: 'createTime', field: 'createTime', align: 'left', sortable: true },
        { name: 'opt', field: 'opt', align: 'right'},
    	],
    	listData:[],
		dialogType:0,
		dialogStatus:false,
		content:null,
    }
  },
  props:['lang'],
  filters: {
    	parseDateTime(time){
    		return time?parseDateTime(time):time;
    	}
    },
  watch:{
  	lang(val, oldVal){
    	this.columns = this.columns;
    },
    pageCount(val, oldVal){//选每页数量 size
    	if(val){
    		this.curPage = 1;
    		this.getData(this.curPage);
    	}
    },
  },
  computed: {
	  			screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
  	nextPage(){
  		return this.curPage>=Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	totalPage(){
  		return Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	pageCount(){
  		return this.page.rowsPerPage;
  	}
  },
  created(){
  	if(localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length>0) {
    	this.getData(1);
  	}else{
  		this.$router.replace('/');//login
  	}
  },
  methods: {
  	openDialog(type){
  		this.dialogType = type;
  		this.dialogStatus = true;
  	},
	dateOpt1 (date) {
	  return date <= this.date2;
	},
	dateOpt2 (date) {
		if(this.date1){
			return date >= this.date1 && date <= parseDate1(DATE.getTime());
		}else{
			return date <= parseDate1(DATE.getTime());
		}
	},
  	getData(index){
    	this.listData = [];
    	this.loading = true;
    	var request = {};
    	if(this.use_date){
    		if(this.date1) request.startTime = new Date(this.date1+' 00:00:00').getTime();
    		request.endTime = new Date(this.date2+' 23:59:59').getTime();
		}
    	request.paging = { index:(index-1)*this.page.rowsPerPage, count:this.page.rowsPerPage, sort:'desc' };
    	this.$ajax(1,'post',true,'/systemLog/list',request).then((res)=>{
    		this.listData = res.data;
    		this.total = res.paging.total;
    		setTimeout(() => { this.loading = false }, 800);
    	}).catch((err)=>{
    		console.log(err)
    		setTimeout(() => { this.loading = false }, 800);
    		this.$emit('islogin',index==1?0:1,err);
    		//if(err.code) this.$notify(2,err.msg,null);
    	})
    },
  	btnClick(type,index){
  		if(type===0){
  			this.content = JSON.parse(JSON.stringify(this.listData[index]));
  			/*this.$ajax(1,'get',true,'/media/showMedia/'+id,null).then((res)=>{
  			}).catch((err)=>{ })*/
  		}
  		this.openDialog(type);
  	},
  	confirm(){

  	},
  	pageClick(type){//点击页数 type:0-,1+
    	this.curPage= type? this.curPage+1:this.curPage-1;
    	if(this.curPage>0&&this.total!==0&&this.listData.length<this.total){
    		this.getData(this.curPage);
    	}
    },
  }
}
</script>
